import React, { ChangeEventHandler, CSSProperties, useContext } from "react";
import './css/singlechoice.css';
import Select, { StylesConfig } from "react-select";
import QuestContext from "../QuestWrapper";

type SelectedStyle = {
  accentColor?: string,
  borderColor?: string,
  color?: string
}

interface SingleChoiceProps {
  options: string[] | any;
  checked: string;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  style?: CSSProperties;
  selectedStyle?: SelectedStyle;
  type?: "modal1" | "modal2" | "modal3" | string;
  hoverBackground?:string | any;
}

const SingleChoice: React.FC<SingleChoiceProps> = ({
  options,
  checked,
  onChange,
  style,
  selectedStyle = {accentColor: "#6525B3"},
  type,
  hoverBackground
}) => {

  const { themeConfig } = useContext(QuestContext.Context);

  const containerStyle: CSSProperties = {
    ...style,
    flexDirection: type === 'modal2' ? 'column' : 'row',
    gap: type === 'modal2' ? '12px' : '8px'
  };

  const customStyles: StylesConfig<any, false, any> = {
    control: (base) => ({
      ...base,
      background: containerStyle?.background || containerStyle?.backgroundColor || "transparent",
      fontSize: containerStyle?.fontSize || "14px",
      border: `${containerStyle?.borderWidth || "1px"} solid ${containerStyle?.borderColor || style?.borderColor || "var(--neutral-grey-100, #ECECEC)"}`,
      borderRadius: style?.borderRadius || "10px",
      color: containerStyle?.color || style?.color || "black",
      fontFamily: containerStyle?.fontFamily || "'Figtree', sans-serif",
      boxShadow: "none",
      '&:hover': {
        border: `${containerStyle?.borderWidth || "1px"} solid ${containerStyle?.borderColor || style?.borderColor || "var(--neutral-grey-100, #ECECEC)"}`,
        boxShadow: "none"
      },
      ...containerStyle
    }),
    option: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: isFocused ? hoverBackground?.background || "#ADD8E6" : (containerStyle?.background || containerStyle?.backgroundColor || "#f9fafb") as string,
        color: isFocused ? "white" : containerStyle?.color || style?.color || "black",
        fontSize: containerStyle?.fontSize || "14px",
        fontFamily: containerStyle?.fontFamily || "'Figtree', sans-serif",
        '&:active': {
          backgroundColor: hoverBackground?.background || "#ADD8E6",
          color: "white",
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: (containerStyle?.background || containerStyle?.backgroundColor || "#f9fafb") as string,
    }),

    singleValue: (provided) => ({
        ...provided,
        color: containerStyle?.color || style?.color || "black",
        fontSize: containerStyle?.fontSize || "14px",
        fontFamily: containerStyle?.fontFamily || "'Figtree', sans-serif",
    }),
  };
  return (
    (type === "modal3") ?
    <div>
      <Select
        isSearchable={true} 
        name={"selectbox"} 
        options={options.map((opt: string) => {return {value: opt, label: opt}})} 
        onChange={onChange}
        styles={customStyles}
        value={!!checked ? {value: checked, label: checked} : ""}
      />
    </div>
    :
    <div className="q-singlechoice-input-cont" style={containerStyle}>
      {options.map((option: string, id: number) => {
        const labelContainerStyle: CSSProperties = {
          border: checked === option
          ? `1px solid ${selectedStyle?.borderColor || selectedStyle?.accentColor || '#6525B3'}`
          : `1px solid ${style?.borderColor || "#EFEFEF"}`,
          width: type === 'modal2' ? '100%' : 'fit-content',
          padding: type === 'modal2' ? '10px 16px' : '8px 16px',
          gap: type === 'modal2' ? '8px' : '4px',
        };

        return (
          <div className="q_singlehoice_label_cont" key={id} style={labelContainerStyle}>
            <input
              type="radio"
              value={option}
              checked={checked === option}
              onChange={onChange}
              className="q-singlechoice-input"
              style={{ accentColor: selectedStyle?.accentColor || "#6525B3"}}
              id={option}
            />
            <label style={{ color: checked === option ? (selectedStyle?.color || selectedStyle?.accentColor || "#6525B3") : (style?.color || '#939393') }} htmlFor={option}>{option}</label>
          </div>
        );
      })}
    </div>
  );
};

export default SingleChoice;
